module.exports = __webpack_public_path__ + "img/title-hk.ee296e1a.png";